import { render, staticRenderFns } from "./CaseDetails.vue?vue&type=template&id=01f00eb0&scoped=true"
import script from "./CaseDetails.vue?vue&type=script&lang=js"
export * from "./CaseDetails.vue?vue&type=script&lang=js"
import style0 from "./CaseDetails.vue?vue&type=style&index=0&id=01f00eb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f00eb0",
  null
  
)

export default component.exports